/* Magic Milk - Glas-Navigation, Text-Effekte, Bewegung, UI.
   Ohne Fremdbibliothek. Nur transform/opacity/filter/clip-path/box-shadow/backdrop-filter. */
(function () {
  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ROT = '#E5142A', PINK = '#FF4B7E', K = 'cubic-bezier(.22,.61,.36,1)';

  var css = [
    '#mmFortschritt{position:fixed;top:0;left:0;height:3px;width:100%;z-index:99999;',
      'background:linear-gradient(90deg,' + ROT + ',' + PINK + ');transform:scaleX(0);',
      'transform-origin:0 50%;pointer-events:none;will-change:transform}',

    '.header__row.header__navigation-bar-row{display:none!important}',
    '#mmNaviPlatz{padding:6px 0}',
    '#mmNavi{--g:rgba(21,16,19,.72);position:relative;z-index:9990;margin:0 auto;box-sizing:border-box;',
      'width:calc(100% - 24px);max-width:1180px;display:flex;align-items:center;gap:14px;',
      'padding:9px 14px;border-radius:999px;background:var(--g);',
      '-webkit-backdrop-filter:blur(18px) saturate(165%);backdrop-filter:blur(18px) saturate(165%);',
      'border:1px solid rgba(255,255,255,.14);',
      'box-shadow:0 10px 34px rgba(21,16,19,.20), inset 0 1px 0 rgba(255,255,255,.10);',
      'transition:transform .34s ' + K + ',box-shadow .34s ease,background .34s ease}',
    '#mmNavi.schwebt{position:fixed;top:calc(8px + env(safe-area-inset-top));left:50%;',
      'transform:translateX(-50%);--g:rgba(21,16,19,.88);',
      'box-shadow:0 14px 44px rgba(21,16,19,.34), inset 0 1px 0 rgba(255,255,255,.12)}',
    '#mmWechsel{flex:none;display:flex;align-items:center;gap:8px;color:rgba(255,255,255,.62);',
      'font-size:12px;white-space:nowrap}',
    '#mmWechsel .punkt{width:7px;height:7px;border-radius:50%;flex:none;',
      'background:linear-gradient(135deg,' + ROT + ',' + PINK + ');animation:mmPuls 2.4s ' + K + ' infinite}',
    '@keyframes mmPuls{0%{box-shadow:0 0 0 0 rgba(255,75,126,.5)}',
      '70%{box-shadow:0 0 0 8px rgba(255,75,126,0)}100%{box-shadow:0 0 0 0 rgba(255,75,126,0)}}',
    '#mmWort{position:relative;display:inline-block;height:17px;overflow:hidden;min-width:8.4em}',
    '#mmWort b{position:absolute;left:0;top:0;font-weight:600;font-size:12.5px;color:#fff;',
      'white-space:nowrap;opacity:0;transform:translateY(100%);',
      'transition:opacity .45s ' + K + ',transform .45s ' + K + '}',
    '#mmWort b.da{opacity:1;transform:translateY(0)}',
    '#mmWort b.weg{opacity:0;transform:translateY(-100%)}',
    '#mmNavi nav{flex:1 1 auto;display:flex;align-items:center;gap:2px;min-width:0;',
      'overflow-x:auto;scrollbar-width:none;-ms-overflow-style:none}',
    '#mmNavi nav::-webkit-scrollbar{display:none}',
    '#mmNavi nav a{position:relative;flex:none;color:rgba(255,255,255,.82);text-decoration:none;',
      'font-size:13.5px;font-weight:500;padding:8px 13px;border-radius:999px;white-space:nowrap;',
      'transition:color .22s ease,background .22s ease,transform .22s ' + K + '}',
    '@media (hover:hover){#mmNavi nav a:hover{color:#fff;background:rgba(255,255,255,.10);',
      'transform:translateY(-1px)}}',
    '#mmNavi nav a:active{transform:translateY(0) scale(.97)}',
    '#mmNavi nav a:focus-visible{outline:2px solid ' + PINK + ';outline-offset:2px}',
    '#mmNavi .mmCta{flex:none;color:#fff;text-decoration:none;font-size:13px;font-weight:600;',
      'padding:9px 17px;border-radius:999px;white-space:nowrap;',
      'background:linear-gradient(135deg,' + ROT + ',' + PINK + ');',
      'box-shadow:0 4px 14px rgba(229,20,42,.34);',
      'transition:transform .22s ' + K + ',box-shadow .22s ease}',
    '@media (hover:hover){#mmNavi .mmCta:hover{transform:translateY(-2px);',
      'box-shadow:0 8px 22px rgba(229,20,42,.5)}}',
    '@media (max-width:760px){',
      '#mmNavi{flex-wrap:wrap;gap:8px 10px;padding:9px 12px;border-radius:22px;width:calc(100% - 16px)}',
      '#mmNavi.schwebt{border-radius:22px}',
      '#mmWechsel{order:1;flex:1 1 auto;font-size:11.5px}',
      '#mmNavi .mmCta{order:2;padding:7px 14px;font-size:12.5px}',
      '#mmNavi nav{order:3;flex:1 1 100%;',
        '-webkit-mask-image:linear-gradient(90deg,#000 90%,transparent);',
        'mask-image:linear-gradient(90deg,#000 90%,transparent)}',
      '#mmNavi nav a{font-size:13px;padding:7px 11px}}',

    /* Wortweise einfliegen mit Weichzeichner */
    '.mmTeil{display:inline-block;white-space:pre;opacity:0;',
      'transform:translateY(18px);filter:blur(10px);',
      'transition:opacity .5s ' + K + ',transform .5s ' + K + ',filter .5s ' + K + '}',
    '.mmTeil.da{opacity:1;transform:translateY(0);filter:blur(0)}',

    /* Textmarker - der Balken wird von links nach rechts gezogen */
    '.mmMarker{position:relative;display:inline-block;isolation:isolate;',
      '-webkit-text-fill-color:currentColor;background:none;',
      'transition:color .35s ease .3s}',
    '.mmMarker::before{content:"";position:absolute;z-index:-1;',
      'left:-.14em;right:-.14em;top:.06em;bottom:.04em;',
      'background:linear-gradient(100deg,' + ROT + ' 0%,' + PINK + ' 100%);',
      'border-radius:3px;transform:skewY(-1.2deg);',
      'clip-path:inset(0 100% 0 0);',
      'transition:clip-path .62s ' + K + '}',
    '.mmMarker.da::before{clip-path:inset(0 0 0 0)}',
    '.mmMarker.da{color:#fff}',

    /* Buchstaben fallen mit Aufprall */
    /* Die Wortklammer: haelt die Buchstaben eines Wortes zusammen, damit
       der Umbruch nur zwischen Woertern passieren kann. */
    '.mmWort{display:inline-block;white-space:nowrap}',
    '.mmZ{display:inline-block;white-space:pre;opacity:0}',
    '.mmZ.da{animation:mmFall .95s ' + K + ' both}',
    '@keyframes mmFall{',
      '0%{transform:translateY(-150px) rotate(-8deg);opacity:0}',
      '12%{opacity:1}',
      '48%{transform:translateY(0) rotate(0)}',
      '60%{transform:translateY(-20px) rotate(2deg)}',
      '72%{transform:translateY(0) rotate(0)}',
      '82%{transform:translateY(-8px)}',
      '91%{transform:translateY(0)}',
      '96%{transform:translateY(-3px)}',
      '100%{transform:translateY(0);opacity:1}}',

    '.st_card,.resource-card,.product-card{transition:transform .32s ' + K + ',box-shadow .32s ease}',
    '@media (hover:hover){.st_card:hover,.resource-card:hover,.product-card:hover{',
      'transform:translateY(-6px);box-shadow:0 16px 38px rgba(0,0,0,.18)}}',
    '.button,.btn,button[name="add"],.shopify-payment-button__button{',
      'transition:transform .2s ' + K + ',box-shadow .2s ease,filter .2s ease}',
    '@media (hover:hover){.button:hover,.btn:hover,button[name="add"]:hover,',
      '.shopify-payment-button__button:hover{transform:translateY(-2px);',
      'box-shadow:0 8px 22px rgba(0,0,0,.18);filter:saturate(1.08)}}',
    '.button:active,.btn:active,button[name="add"]:active{transform:translateY(0) scale(.98)}',
    '@media (hover:hover){.st_story-circle{transition:transform .3s ' + K + '}',
      '.st_story-circle:hover{transform:scale(1.07)}}',
    '@media (prefers-reduced-motion:reduce){*{transition-duration:.01ms!important;',
      'animation-duration:.01ms!important}}'
  ].join('');
  var st = document.createElement('style');
  st.id = 'mm-bewegung-stil';
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  var LINKS = [['Angebote','/collections/all'],['SETs','/collections/sets'],
               ['Track order','/a/track'],['Häufige Fragen','/#faq']];
  var WORTE = ['Zunehmen','Abnehmen','Mehr Energie','Mehr Appetit'];

  function imBlick(el, tun) {
    if (!('IntersectionObserver' in window)) { tun(); return; }
    var b = new IntersectionObserver(function (e) {
      e.forEach(function (x) { if (x.isIntersecting) { b.disconnect(); tun(); } });
    }, { threshold: 0.2 });
    b.observe(el);
  }

  /* ===== Wortweise einfliegen + Textmarker auf dem Markennamen ===== */
  function zerlegen(el) {
    var teile = [];
    var kinder = [].slice.call(el.childNodes);
    var neu = document.createDocumentFragment();
    kinder.forEach(function (kn) {
      if (kn.nodeType === 3) {
        kn.textContent.split(/(\s+)/).forEach(function (w) {
          if (w === '') return;
          var s = document.createElement('span');
          s.className = 'mmTeil';
          s.textContent = w;
          neu.appendChild(s);
          if (w.trim() !== '') teile.push(s);
        });
      } else if (kn.nodeType === 1) {
        kn.classList.add('mmTeil');
        if (kn.classList.contains('highlight')) kn.classList.add('mmMarker');
        neu.appendChild(kn);
        teile.push(kn);
      }
    });
    el.innerHTML = '';
    el.appendChild(neu);
    return teile;
  }

  function textEffekt() {
    var ziele = document.querySelectorAll(
      '.st_section_slider_card_collection-title-header,' +
      '.st_section_slider_card_collection-title-subt'
    );
    [].forEach.call(ziele, function (el) {
      if (el.dataset.mmT) return;
      el.dataset.mmT = '1';
      if (ruhig) return;
      var teile = zerlegen(el);
      if (!teile.length) return;

      function alleZeigen() {
        teile.forEach(function (t) { t.classList.add('da'); });
      }
      setTimeout(alleZeigen, 8000); // Notbremse

      imBlick(el, function () {
        teile.forEach(function (t, i) {
          setTimeout(function () { t.classList.add('da'); }, i * 60);
        });
      });
    });
  }

  /* ===== Buchstaben fallen mit Aufprall - kurze Sektions-Ueberschriften ===== */
  function fallEffekt() {
    var kandidaten = document.querySelectorAll('#MainContent h2, #MainContent h3');
    var gemacht = 0;
    [].forEach.call(kandidaten, function (h) {
      if (gemacht >= 3) return;
      if (h.dataset.mmF) return;
      var t = (h.textContent || '').trim();
      if (!t || t.length > 30 || h.children.length > 0) return;
      if (h.closest('.swiper-slide, .swiper, footer')) return;
      if (h.offsetHeight === 0) return;
      h.dataset.mmF = '1';
      gemacht++;
      if (ruhig) return;

      /* 29.08.2026, Mert (zweimal gemeldet): "das s darf nicht allein unten
         stehen" und spaeter "OVER 10.000+ P / EOPLE TRUST US".
         URSACHE: Jeder Buchstabe wurde ein eigenes `inline-block` - und zwischen
         zwei inline-block-Elementen darf der Browser IMMER umbrechen, auch
         mitten im Wort. Kein `word-break` und kein `text-wrap` hilft dagegen,
         weil es fuer den Browser gar kein zusammenhaengendes Wort mehr ist.
         GEMESSEN: "PEOPLE" braucht 49 px und hatte 314 px Platz - es war also
         nie zu eng, nur falsch zerlegt.
         LOESUNG: Erst in WOERTER teilen, dann innerhalb des Wortes in
         Buchstaben. Das Wort selbst ist eine Klammer, die nicht bricht; zwischen
         den Woertern bleibt der Umbruch normal erlaubt. Die Animation laeuft
         unveraendert Buchstabe fuer Buchstabe. */
      var zeichen = [];
      var frag = document.createDocumentFragment();
      t.split(/(\s+)/).forEach(function (stueck) {
        if (!stueck) return;
        if (/^\s+$/.test(stueck)) {
          /* Leerzeichen bleiben normaler Text - nur hier darf umgebrochen werden. */
          frag.appendChild(document.createTextNode(stueck));
          return;
        }
        var wort = document.createElement('span');
        wort.className = 'mmWort';
        stueck.split('').forEach(function (c) {
          var s = document.createElement('span');
          s.className = 'mmZ';
          s.textContent = c;
          wort.appendChild(s);
          zeichen.push(s);
        });
        frag.appendChild(wort);
      });
      h.innerHTML = '';
      h.appendChild(frag);

      setTimeout(function () {
        zeichen.forEach(function (z) { z.classList.add('da'); });
      }, 8000); // Notbremse

      imBlick(h, function () {
        zeichen.forEach(function (z, i) {
          setTimeout(function () { z.classList.add('da'); }, i * 45);
        });
      });
    });
  }

  function navigation() {
    /* 19.08.2026 Mert: "raus damit" - alle eigenen Navigationsleisten sind
       entfallen, der Kopf des Themes (Menue, Suche, Logo, Konto, Korb)
       macht die Navigation allein.

       WICHTIG, warum hier ein Riegel steht und nicht nur die Aufrufe weg
       sind: diese Leiste wurde bisher von mm-navi2.js per
       '#mmNaviPlatz{display:none!important}' verdeckt, nicht geloescht.
       Nimmt man nur mm-navi2.js aus theme.liquid, kommt sie zurueck - dann
       hat man wieder eine Leiste, die keiner wollte. Der Riegel schliesst
       das aus, an der Quelle.
       Der Bau bleibt darunter stehen, falls die Leiste je zurueck soll. */
    return;

    /* eslint-disable no-unreachable */
    if (document.getElementById('mmNavi')) return;
    var alt = document.querySelector('.header__row.header__navigation-bar-row');
    if (!alt || !alt.parentElement) return;

    var platz = document.createElement('div');
    platz.id = 'mmNaviPlatz';
    var leiste = document.createElement('div');
    leiste.id = 'mmNavi';

    var wechsel = document.createElement('div');
    wechsel.id = 'mmWechsel';
    wechsel.innerHTML = '<span class="punkt"></span><span>Für dein Ziel:</span><span id="mmWort"></span>';
    leiste.appendChild(wechsel);

    var nav = document.createElement('nav');
    nav.setAttribute('aria-label', 'Hauptmenü');
    LINKS.forEach(function (l) {
      var a = document.createElement('a');
      a.href = l[1]; a.textContent = l[0];
      nav.appendChild(a);
    });
    leiste.appendChild(nav);

    var cta = document.createElement('a');
    cta.className = 'mmCta'; cta.href = '/collections/all';
    cta.textContent = 'Zu den Produkten';
    leiste.appendChild(cta);

    alt.parentElement.insertBefore(platz, alt.nextSibling);
    platz.appendChild(leiste);

    var topf = document.getElementById('mmWort');
    if (topf && !ruhig) {
      var i = 0, aktuell = null;
      var naechstes = function () {
        var b = document.createElement('b');
        b.textContent = WORTE[i % WORTE.length];
        topf.appendChild(b);
        requestAnimationFrame(function () { b.classList.add('da'); });
        if (aktuell) {
          var a2 = aktuell;
          a2.classList.remove('da'); a2.classList.add('weg');
          setTimeout(function () { if (a2.parentNode) a2.parentNode.removeChild(a2); }, 600);
        }
        aktuell = b; i++;
      };
      naechstes();
      setInterval(naechstes, 2600);
    } else if (topf) {
      topf.innerHTML = '<b class="da">Zunehmen oder Abnehmen</b>';
    }

    var tickt2 = false;
    function pruefe() {
      var schwebt = leiste.classList.contains('schwebt');
      var r = platz.getBoundingClientRect();
      if (!schwebt && r.top < 4) {
        platz.style.height = platz.offsetHeight + 'px';
        leiste.classList.add('schwebt');
      } else if (schwebt && r.top > 6) {
        leiste.classList.remove('schwebt');
        platz.style.height = '';
      }
      tickt2 = false;
    }
    window.addEventListener('scroll', function () {
      if (!tickt2) { tickt2 = true; requestAnimationFrame(pruefe); }
    }, { passive: true });
    window.addEventListener('resize', function () {
      leiste.classList.remove('schwebt'); platz.style.height = ''; pruefe();
    }, { passive: true });
    pruefe();
  }

  function bedienelemente() {
    if (document.getElementById('mmFortschritt')) return;
    var bar = document.createElement('div');
    bar.id = 'mmFortschritt';
    document.body.appendChild(bar);

    /* 19.08.2026 Mert: "raus damit pfeil weg" - der runde Nach-oben-Knopf
       unten links ist entfallen. Der Fortschrittsbalken oben BLEIBT, das
       war nicht gemeint. Falls der Knopf je zurueck soll: Erzeugung hier
       wieder einsetzen, die Zeile mit hoch.classList.toggle in mal()
       ebenfalls, und die vier #mmHoch-Regeln im Stilblatt oben. */

    var tickt = false;
    function mal() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (h > 0 ? window.scrollY / h : 0).toFixed(4) + ')';
      tickt = false;
    }
    window.addEventListener('scroll', function () {
      if (!tickt) { tickt = true; requestAnimationFrame(mal); }
    }, { passive: true });
    mal();
  }

  var M = 'mmB', beob = null;

  function zeigen(el, verzug) {
    if (el.dataset[M] === 'fertig') return;
    el.dataset[M] = 'fertig';
    el.style.transitionDelay = (verzug || 0) + 'ms';
    el.style.transition = 'opacity .8s ' + K + ', transform .8s ' + K;
    el.style.opacity = '1';
    el.style.transform = 'translateY(0) scale(1)';
    setTimeout(function () {
      el.style.transform = 'none'; el.style.willChange = 'auto';
      el.style.transition = ''; el.style.transitionDelay = '';
    }, 1000 + (verzug || 0));
  }

  function vorbereiten(el, weg) {
    el.dataset[M] = 'wartet';
    el.style.opacity = '0';
    el.style.transform = 'translateY(' + weg + 'px) scale(.985)';
    el.style.willChange = 'opacity, transform';
    beob.observe(el);
    setTimeout(function () {
      if (el.style.opacity === '0') { beob.unobserve(el); zeigen(el, 0); }
    }, 12000);
  }

  function durchlauf() {
    document.documentElement.style.scrollBehavior = 'smooth';
    navigation();
    textEffekt();
    fallEffekt();
    if (!beob) return;
    var sektionen = document.querySelectorAll('#MainContent > .shopify-section');
    [].forEach.call(sektionen, function (sek) {
      if (sek.dataset[M]) return;
      if (sek.offsetHeight === 0) return;
      if (sek.getBoundingClientRect().top < window.innerHeight * 0.85) {
        sek.dataset[M] = 'fertig'; return;
      }
      vorbereiten(sek, 34);
      var karten = sek.querySelectorAll('.st_card,.resource-card,.product-card');
      var n = 0;
      [].forEach.call(karten, function (k) {
        if (k.dataset[M]) return;
        if (k.closest('.swiper-slide, .swiper')) return;
        if (n > 7) return;
        k.dataset.mmVerzug = String(n * 70);
        vorbereiten(k, 22); n++;
      });
    });
  }

  function start() {
    bedienelemente();
    navigation();
    textEffekt();
    fallEffekt();
    if (!ruhig) {
      beob = new IntersectionObserver(function (e) {
        e.forEach(function (x) {
          if (!x.isIntersecting) return;
          beob.unobserve(x.target);
          zeigen(x.target, parseInt(x.target.dataset.mmVerzug || '0', 10));
        });
      }, { rootMargin: '0px 0px -14% 0px', threshold: 0.08 });
    }
    durchlauf();
    window.addEventListener('load', durchlauf);
    setTimeout(durchlauf, 1200);
    setTimeout(durchlauf, 3000);
    setTimeout(durchlauf, 6000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
})();
